import { useInspectorContext } from "~/components/design-system/pages/internal/InspectorContext"

const ModuleViewConfiguration = () => {
  const { viewConfiguration } = useInspectorContext()
  if (!viewConfiguration) return null

  return <div className="w-full shrink-0 border-b border-base">{viewConfiguration}</div>
}

export default ModuleViewConfiguration
